import { trainingService } from "@crescentParts/Services/TrainingRegistrationService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface TrainingFormParameter {
    TrainingName: string;
    Location: string;
    StartDate: string;
    EndDate: string;
    Name: string;
    CompanyName: string;
    Phone: string;
    Email: string;
    TM: string;
    PaymentMethod: string;
    totalJoiningCount: string;
    onSuccess: (result: any) => void;
    onError: (error: string) => void;
}

type HandlerType = Handler<TrainingFormParameter>;

export const Register: HandlerType = async props => {
    const data = {
        TrainingName: props.parameter.TrainingName,
        Name: props.parameter.Name,
        CompanyName: props.parameter.CompanyName,
        Phone: props.parameter.Phone,
        Email: props.parameter.Email,
        TM: props.parameter.TM,
        PaymentMethod: props.parameter.PaymentMethod,
        Location: props.parameter.Location,
        StartDate: props.parameter.StartDate,
        EndDate: props.parameter.EndDate,
        joiningCount: props.parameter.totalJoiningCount
    };
    try {
        const result = await trainingService({ trainingForm: data });

        if (result.successful) {
            props.parameter.onSuccess(result.result);
        } else {
            props.parameter.onError(result?.errorMessage);
        }
    } catch (err) {
        props.parameter.onError(err?.errorMessage || err);
    }
};

export const chain = [Register];

const submitTraining = createHandlerChainRunner(chain, "SubscribeNewsletter");
export default submitTraining;
